<template>
  <div id="Information" dir="rtl">
    <div class="row">
      <div class="col-md-12 text-right">
        <div class="form-inlin">
          <div class="form-group mb-2">
            <label for="lblId" class="text-right"> کد رهگیری : </label>
            <span class="text-right font-weight-bold">
              {{ this.info.Id }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <div class="form-inlin">
          <div class="form-group mb-2">
            <label for="lblId" class="text-right"> تاریخ ایجاد : </label>
            <span class="text-right font-weight-bold">
              {{ this.info.ZamanInsert }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <div class="form-inlin">
          <div class="form-group mb-2">
            <label for="lblId" class="text-right"> ایجاد کننده : </label>
            <span class="text-right font-weight-bold">
              {{ this.info.TblUserGrpIdInsert }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <div class="form-inlin">
          <div class="form-group mb-2">
            <label for="lblId" class="text-right"> زمان آخرین تغییرات : </label>
            <span class="text-right font-weight-bold">
              {{ this.info.ZamanLastEdit }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right">
        <div class="form-inlin">
          <div class="form-group mb-2">
            <label for="lblId" class="text-right"> آخرین تغییر دهنده : </label>
            <span class="text-right font-weight-bold">
              {{ this.info.TblUserGrpIdLastEdit }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="text-right">     
            <a href="javascript:;" @click="gotolog(info.Id)" class="badge" title="جزئیات" ><span class="fas fa-trash-alt text-danger" style="font-size:13px;"></span></a>
        </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: null,
    };
  },
  beforeMount() {
    console.log(this.$store.state.Information);
    this.info = this.$store.state.Information;
  },
  methods: {
    gotolog(Id) {
      this.$router.push({
        name: "DetailUserLogInformation",
        params: { Status: Id },
      });
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
    },
  },
};
</script>
<style scoped></style>
